import React from 'react';
import {
    Table,
    Form,
    Button,
    Popup,
    Dropdown,
    Input,
    Segment,
    Header,
    Icon,
    Grid,
    Loader,
    Label
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import ReactExport from 'react-data-export';
import moment from 'moment';
import SearchTableData from '../util/SearchTableData';
import { HeaderCursor } from '../Professor/ProfessorInputGrades/css';
import PaginationFront from '../util/PaginationFront';
import { sanitizeExcelDataSet } from '../util/sanitizeExcel';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;
const { ExcelColumn } = ReactExport.ExcelFile;

const additionalFundingOptions = [
    { key: 1, value: 'Da', text: 'Da' },
    { key: 2, value: 'Ne', text: 'Ne' },
];

function NoDataMessage() {
    return null;
}

class EmploymentList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: [],
            editId: null,
            deleteId: null,
            newRow: false,
            formData: {
                member: '',
                request: '',
                jobTitle: '',
                contractPeriod: '',
                teachingType: '',
                additionalFunding: '',
                reason: '',
                numExecutors: '',
                unionOpinion: '',
                governmentApproval: '',

            },
            loader: false,
            membersOptions: [],
            contractTypeOptions: [],
            teachingTypeOptions: [],
            contractReasonOptions: [],
            jobTitleOptions: [],
            employmentData: [],
            results: [],
            activePage: 1,
            activeIndex: this.props.location.state? this.props.location.state.activeIndex: 0,
            postsPerPage: 20,
            currentPosts: [],

            excelData: [
                {
                    columns: [],
                    data: []
                }
            ],

        };
        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);

    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        if (this.state.activeIndex === 0) {
            return this.state.rows.filter(el => el.id);
        }
        if (this.state.activeIndex === 1) {
            return this.state.rows.filter(el => !el.id);
        }
        return this.state.rows;
    }

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, {activePage: 1})
    }
    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    startEdit = (id) => {
        const row = this.state.rows.find((r) => r.id === id);
        this.setState({
            editId: id,
            newRow: false,
            formData: { ...row },
        });
    };

    cancelEdit = () => {
        this.setState({
            editId: null,
            newRow: false,
            formData: {
                member: '',
                request: '',
                jobTitle: '',
                contractPeriod: '',
                teachingType: '',
                additionalFunding: '',
                reason: '',
                numExecutors: '',
                unionOpinion: '',
                governmentApproval: '',
            },
        });
    };



    saveRow = () => {
        const { newRow, editId, formData, rows } = this.state;

        if (
            !formData.member ||
            !formData.request ||
            !formData.jobTitle ||
            !formData.contractPeriod ||
            !formData.teachingType ||
            !formData.additionalFunding ||
            !formData.reason ||
            !formData.numExecutors
        ) {
            toast('Popunite sva polja!');
            return;
        }

        const number = parseInt(formData.numExecutors, 10);
        if (isNaN(number) || number < 1) {
            toast('Broj izvršilaca mora biti cijeli broj!');
            return;
        }

        const member = this.state.membersOptions.find(m => m.value === formData.member);
        const jobTitle = this.state.jobTitleOptions.find(j => j.value === formData.jobTitle);
        const contractType = this.state.contractTypeOptions.find(c => c.value === formData.contractPeriod);
        const employeeType = this.state.teachingTypeOptions.find(e => e.value === formData.teachingType);
        const contractEndReason = this.state.contractReasonOptions.find(r => r.value === formData.reason);

        const payload = {
            organizationalUnit: { id: member ? member.key : null },
            jobTitle: { id: jobTitle ? jobTitle.key : null },
            period: { id: contractType ? contractType.key : null },
            employeeType: { id: employeeType ? employeeType.key : null },
            contractEndReason: { id: contractEndReason ? contractEndReason.key : null },
            additionalFunds: formData.additionalFunding === "Da",
            numberOfExecutors: number,
            request: formData.request,
            opinion: formData.unionOpinion,
            consent: formData.governmentApproval,
            note: formData.note
        };

        const activeRole = localStorage.getItem('activeRole');

        this.setState({ loader: true });

        if (!newRow && editId !== null) {
            payload.id = editId;

            const url = activeRole && activeRole.substr(0, 9) === 'HR admin:'
                ? `employer-list/update`
                : `employer-list/update`;

            axios.put(url, payload)
                .then(() => {
                    this.fetchAllEmploymentData();
                    const updatedRows = rows.map(row =>
                        row.id === editId ? { ...formData, id: editId } : row
                    );

                    this.setState({
                        rows: updatedRows,
                        editId: null,
                        loader: false,
                        formData: {
                            member: '',
                            request: '',
                            jobTitle: '',
                            contractPeriod: '',
                            teachingType: '',
                            additionalFunding: '',
                            reason: '',
                            numExecutors: '',
                            unionOpinion: '',
                            governmentApproval: '',
                            note: ''
                        }
                    });

                    toast("Uspješno ažurirano!");
                })
                .catch(error => {
                    console.error("Greška prilikom ažuriranja:", error);
                    toast("Greška prilikom ažuriranja.");
                    this.setState({ loader: false });
                });

        } else {
            const url = activeRole && activeRole.substr(0, 9) === 'HR admin:'
                ? `employer-list/add`
                : `employer-list/add`;

            axios.post(url, payload)
                .then(() => {
                    this.fetchAllEmploymentData();
                    toast("Uspješno dodano!");
                    this.setState(prevState => ({
                        rows: [...prevState.rows, { ...formData, id: prevState.rows.length + 1 }],
                        newRow: false,
                        editId: null,
                        loader: false,
                        formData: {
                            member: '',
                            request: '',
                            jobTitle: '',
                            contractPeriod: '',
                            teachingType: '',
                            additionalFunding: '',
                            reason: '',
                            numExecutors: '',
                            unionOpinion: '',
                            governmentApproval: '',
                            note: ''
                        }
                    }));
                })
                .catch(error => {
                    console.error("Greška prilikom dodavanja:", error);
                    toast("Greška prilikom dodavanja.");
                    this.setState({ loader: false });
                });
        }
    };



    handleInputChange = (e, { name, value }) => {
        this.setState((prevState) => ({
            formData: {
                ...prevState.formData,
                [name]: value,
            },
        }));
    };

    addNewRow = () => {
        this.setState({
            newRow: true,
            editId: null,
            formData: {
                member: '',
                request: '',
                jobTitle: '',
                contractPeriod: '',
                teachingType: '',
                additionalFunding: '',
                reason: '',
                numExecutors: '',
                unionOpinion: '',
                governmentApproval: '',
            },
        });
    };

    deleteRow = async (id) => {
        const ordinal = localStorage.getItem("ordinal");
        const url =
            localStorage.getItem("activeRole").substr(0, 9) === "HR admin:"
                ? `employer-list/${id}`
                : `employer-list/${id}`;

        try {
            await axios.delete(url);
            this.setState((prevState) => ({
                rows: prevState.rows.filter((row) => row.id !== id),
                editId: prevState.editId === id ? null : prevState.editId,
                newRow: prevState.newRow && prevState.editId === id ? false : prevState.newRow,
            }));
            toast("Uspješno obrisano!");
        } catch (error) {
            console.error("Greška prilikom brisanja:", error);
            toast("Greška prilikom brisanja!");
        }
    };

    componentDidMount() {
        this.fetchMembers();
        this.fetchContracts();
        this.fetchTeachingTypes();
        this.fetchConractReason();
        this.fetchJobTitle();
        this.fetchAllEmploymentData();

    }

    fetchMembers = async () => {
        try {
            const response = await axios.get('graduation-documents/faculties');

            const filteredData = response.data.filter(item =>
                item.name !== 'Testni fakultet'
            );

            const formattedOptions = filteredData.map(item => ({
                key: item.id,
                value: item.abbreviation ? item.abbreviation : item.name,
                text: item.abbreviation ? item.abbreviation : item.name,
                title: item.name
            }));

            this.setState({ membersOptions: formattedOptions });

        } catch (error) {
            console.error('Greška prilikom dohvata članica:', error);
        }
    };


    fetchContracts = async () => {
        try {
            const response = axios({
                method: 'get',
                url: 'contract-types',
            }).then(res => {res.data

                const formattedOptions = res.data.map((item, index) => ({
                    key: item.id,
                    value: item.name,
                    text: item.name
                }));


                this.setState({ contractTypeOptions: formattedOptions });
            });
        } catch (error) {
            console.error('Greška prilikom dohvata članica:', error);
        }
    };

    fetchTeachingTypes = async () => {
        try {
            const response = await axios({
                method: 'get',
                url:  'employee-types',
            });

            const formattedOptions = response.data.map((item, index) => ({
                key: item.id,
                value: item._key,
                text: item._key,
            }));

            this.setState({ teachingTypeOptions: formattedOptions });
        } catch (error) {
            console.error('Greška prilikom dohvata tipova zaposlenja (nastavno/nenastavno):', error);
        }
    };

    fetchConractReason = async () => {
        try {
            const response = await axios({
                method: 'get',
                url: 'contract-end-reasons',
            });

            const formattedOptions = response.data.map((item, index) => ({
                key: item.id,
                value: item.name,
                text: item.name,
            }));

            this.setState({ contractReasonOptions: formattedOptions });
        } catch (error) {
            console.error('Greška prilikom dohvata tipova zaposlenja (nastavno/nenastavno):', error);
        }
    };

    fetchJobTitle = async () => {
        try {
            const response = await axios({
                method: 'get',
                url: 'job-titles',
            });

            const formattedOptions = response.data.map((item, index) => ({
                key: item.id,
                value: item.name,
                text: item.name,
            }));

            this.setState({ jobTitleOptions: formattedOptions });
        } catch (error) {
            console.error('Greška prilikom dohvata tipova zaposlenja (nastavno/nenastavno):', error);
        }
    };

    fetchAllEmploymentData = async () => {
        try {
            const url =  `employer-list/full`;

            const response = await axios.get(url);

            const transformedData = response.data.map((item, index) => ({
                id: item.id,
                member: item.organizationalUnitAbbreviation,
                memberName: item.organizationalUnitName,
                request: item.request,
                jobTitle: item.jobTitleName,
                contractPeriod: item.contractPeriodName,
                teachingType: item.employeeTypeName,
                additionalFunding: item.additionalFunds ? 'Da' : 'Ne',
                reason: item.contractEndReasonName,
                numExecutors: item.numberOfExecutors,
                unionOpinion: item.opinion,
                governmentApproval: item.consent,
                note: item.note,
            }));

            const excelData = [{
                columns: [
                    { title: 'Članica univerziteta', width: { wpx: 500 } },
                    { title: 'Zahtjev', width: { wpx: 225 } },
                    { title: 'Naziv radnog mjesta', width: { wpx: 400 } },
                    { title: 'Period ugovora', width: { wpx: 225 } },
                    { title: 'Osoblje', width: { wpx: 150 } },
                    { title: 'Potrebna dodatna sredstva', width: { wpx: 180 } },
                    { title: 'Razlog', width: { wpx: 400 } },
                    { title: 'Broj izvršilaca', width: { wpx: 130 } },
                    { title: 'Mišljenje sindikata', width: { wpx: 400 } },
                    { title: 'Saglasnost vlade', width: { wpx: 300 } },
                    { title: 'Napomena', width: { wpx: 400 } },
                ],
                data: transformedData.map(el => ([
                    { value: el.memberName },
                    { value: el.request ? el.request : '' },
                    { value: el.jobTitle },
                    { value: el.contractPeriod },
                    { value: el.teachingType },
                    { value: el.additionalFunding },
                    { value: el.reason },
                    { value: el.numExecutors },
                    { value: el.unionOpinion ? el.unionOpinion : '' },
                    { value: el.governmentApproval ? el.governmentApproval : '' },
                    { value: el.note ? el.note : '' },
                ]))
            }];

            this.setState({ rows: transformedData, excelData });
        } catch (error) {
            console.error('Greška prilikom dohvata podataka o zaposlenjima:', error);
        }
    };

    cancelDelete = () => {
        this.setState({ deleteId: null });
    };


    render() {
        const { rows, editId, newRow, formData, loader } = this.state;

        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);


        return (
            <div>
                <h1>Lista za zapošljavanje</h1>
                <Segment.Group raised>
                    <Segment raised>
                        <Grid columns={2} stackable verticalAlign="middle">
                            <Grid.Column width={14}>
                                <Header as="h3">Spisak zahtjeva za zapošljavanje</Header>
                            </Grid.Column>
                            <Grid.Column width={2}>
                                <ExcelFile filename="Lista za zapošljavanje" element={
                                    <Popup
                                        trigger={
                                            <Button
                                                animated={'vertical'}
                                                color="green"
                                                fluid
                                                basic
                                                size="small"
                                                disabled={!this.state.excelData || this.state.excelData.length === 0 || this.state.excelData[0].data.length === 0}>
                                                <Button.Content visible>
                                                    {'Excel'}
                                                </Button.Content>
                                                <Button.Content hidden>
                                                    <Icon name={'download'}></Icon>
                                                </Button.Content>
                                            </Button>
                                        }
                                        content={'Preuzmi spisak u Excel-u'}
                                        hideOnScroll
                                        position="top center"
                                    />
                                }>
                                    <ExcelSheet dataSet={sanitizeExcelDataSet(this.state.excelData)} name="Lista za zapošljavanje"/>
                                </ExcelFile>
                            </Grid.Column>
                        </Grid>
                    </Segment>
                    <Segment clearing>
                            {loader  ?
                                    <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                                    : <div>
                                        {currentPosts.length ?
                                            <div>
                                                <br/>
                                                <Table celled selectable compact size={"small"}>
                                                    <Table.Header>

                                                        <Table.Row>
                                                            <Table.HeaderCell colSpan={12} >
                                                                <Grid stackable>
                                                                    <Grid.Column width={16}>
                                                                        <SearchTableData key={1}
                                                                                         profMozilla
                                                                                         data={this.state.rows.filter(el => el.id)}
                                                                                         getResults={this.getResults}
                                                                                         disabled={false}
                                                                                         filterItem={["additionalFunding",
                                                                                             "contractPeriod",
                                                                                             "governmentApproval",
                                                                                             "id",
                                                                                             "jobTitle",
                                                                                             "member",
                                                                                             "memberName",
                                                                                             "note",
                                                                                             "numExecutors",
                                                                                             "reason",
                                                                                             "request",
                                                                                             "teachingType",
                                                                                             "unionOpinion"
                                                                                         ]} />
                                                                    </Grid.Column>
                                                                </Grid>
                                                            </Table.HeaderCell>
                                                        </Table.Row>

                                                        <Table.Row>
                                                            <Table.HeaderCell width="1.5">Članica univerziteta</Table.HeaderCell>
                                                            <Table.HeaderCell width="2">Zahtjev</Table.HeaderCell>
                                                            <Table.HeaderCell width="2">Naziv radnog mjesta</Table.HeaderCell>
                                                            <Table.HeaderCell width="2">Period ugovora</Table.HeaderCell>
                                                            <Table.HeaderCell width="1.5">Osoblje</Table.HeaderCell>
                                                            <Table.HeaderCell width="1">Potrebna dodatna sredstva</Table.HeaderCell>
                                                            <Table.HeaderCell>Razlog</Table.HeaderCell>
                                                            <Table.HeaderCell width="1">Broj izvršilaca</Table.HeaderCell>
                                                            <Table.HeaderCell >Mišljenje sindikata</Table.HeaderCell>
                                                            <Table.HeaderCell>Saglasnost vlade</Table.HeaderCell>
                                                            <Table.HeaderCell>Napomena</Table.HeaderCell>
                                                            <Table.HeaderCell textAlign="center" verticalAlign="middle">
                                                                <Popup
                                                                    content="Dodaj novi red"
                                                                    position="top center"
                                                                    trigger={
                                                                        <Button
                                                                            icon="add"
                                                                            color="blue"
                                                                            circular
                                                                            basic
                                                                            size="tiny"
                                                                            onClick={this.addNewRow}
                                                                            disabled={newRow || editId !== null}
                                                                        />
                                                                    }
                                                                />
                                                            </Table.HeaderCell>
                                                        </Table.Row>
                                                    </Table.Header>

                                                    <Table.Body verticalAlign="middle">
                                                        {
                                                            newRow &&   <Table.Row key="new">
                                                                {[
                                                                    { name: "member", type: "dropdown", options: this.state.membersOptions },
                                                                    { name: "request", type: "input" },
                                                                    { name: "jobTitle", type: "dropdown", options: this.state.jobTitleOptions },
                                                                    { name: "contractPeriod", type: "dropdown", options: this.state.contractTypeOptions },
                                                                    { name: "teachingType", type: "dropdown", options: this.state.teachingTypeOptions },
                                                                    { name: "additionalFunding", type: "dropdown", options: additionalFundingOptions },
                                                                    { name: "reason", type: "dropdown", options: this.state.contractReasonOptions },
                                                                    { name: "numExecutors", type: "input" },
                                                                    { name: "unionOpinion", type: "input" },
                                                                    { name: "governmentApproval", type: "input" },
                                                                    { name: "note", type: "input" },
                                                                ].map((field, index) => (
                                                                    <Table.Cell verticalAlign="middle" key={index}>
                                                                        {field.type === "dropdown" ? (
                                                                            <Form.Dropdown
                                                                                selection
                                                                                search
                                                                                options={field.options}
                                                                                placeholder={`Odaberite`}
                                                                                name={field.name}
                                                                                value={formData[field.name]}
                                                                                onChange={this.handleInputChange}
                                                                                fluid
                                                                            />
                                                                        ) : (
                                                                            <Form.Input
                                                                                type={field.name === "numExecutors" ? "number" : "text"}
                                                                                min={field.name === "numExecutors" ? 1 : undefined}
                                                                                placeholder={`Unesite`}
                                                                                name={field.name}
                                                                                value={formData[field.name]}
                                                                                onChange={this.handleInputChange}
                                                                                fluid
                                                                            />
                                                                        )}
                                                                    </Table.Cell>
                                                                ))}
                                                                <Table.Cell textAlign="center" verticalAlign="middle" style={{ whiteSpace: 'nowrap' }}>
                                                                    <Button
                                                                        circular
                                                                        color="blue"
                                                                        icon="check"
                                                                        size="tiny"
                                                                        loading={loader}
                                                                        onClick={this.saveRow}
                                                                        disabled={loader}
                                                                    />
                                                                    <Button
                                                                        circular
                                                                        icon="close"
                                                                        size="tiny"
                                                                        basic
                                                                        color="blue"
                                                                        onClick={this.cancelEdit}
                                                                        disabled={loader}
                                                                    />
                                                                </Table.Cell>
                                                            </Table.Row>
                                                        }
                                                        {
                                                            currentPosts.map((row, index) =>
                                                                (
                                                                        <Table.Row key={row.id}>
                                                                            {row.id === editId
                                                                                ? [
                                                                                    { name: "member", type: "dropdown", options: this.state.membersOptions },
                                                                                    { name: "request", type: "input" },
                                                                                    { name: "jobTitle", type: "dropdown", options: this.state.jobTitleOptions },
                                                                                    { name: "contractPeriod", type: "dropdown", options: this.state.contractTypeOptions },
                                                                                    { name: "teachingType", type: "dropdown", options: this.state.teachingTypeOptions },
                                                                                    { name: "additionalFunding", type: "dropdown", options: additionalFundingOptions },
                                                                                    { name: "reason", type: "dropdown", options: this.state.contractReasonOptions },
                                                                                    { name: "numExecutors", type: "input" },
                                                                                    { name: "unionOpinion", type: "input" },
                                                                                    { name: "governmentApproval", type: "input" },
                                                                                    { name: "note", type: "input" },
                                                                                ].map((field, index) => (
                                                                                    <Table.Cell verticalAlign="middle" key={index}>
                                                                                        {field.type === "dropdown" ? (
                                                                                            <Form.Dropdown
                                                                                                selection
                                                                                                search
                                                                                                options={field.options}
                                                                                                placeholder={`Odaberite`}
                                                                                                name={field.name}
                                                                                                value={formData[field.name]}
                                                                                                onChange={this.handleInputChange}
                                                                                                fluid
                                                                                            />
                                                                                        ) : (
                                                                                            <Form.Input
                                                                                                type={field.name === "numExecutors" ? "number" : "text"}
                                                                                                min={field.name === "numExecutors" ? 1 : undefined}
                                                                                                placeholder={`Unesite`}
                                                                                                name={field.name}
                                                                                                value={formData[field.name]}
                                                                                                onChange={this.handleInputChange}
                                                                                                fluid
                                                                                            />
                                                                                        )}
                                                                                    </Table.Cell>
                                                                                ))
                                                                                : (
                                                                                    <React.Fragment>
                                                                                        <Table.Cell verticalAlign="middle"><Popup
                                                                                            content={row.memberName}
                                                                                            position="top center"
                                                                                            trigger={<span>{row.member}</span>}
                                                                                        /></Table.Cell>
                                                                                        <Table.Cell verticalAlign="middle">{row.request}</Table.Cell>
                                                                                        <Table.Cell verticalAlign="middle">{row.jobTitle}</Table.Cell>
                                                                                        <Table.Cell verticalAlign="middle">{row.contractPeriod}</Table.Cell>
                                                                                        <Table.Cell verticalAlign="middle">{row.teachingType}</Table.Cell>
                                                                                        <Table.Cell verticalAlign="middle">{row.additionalFunding}</Table.Cell>
                                                                                        <Table.Cell verticalAlign="middle">{row.reason}</Table.Cell>
                                                                                        <Table.Cell verticalAlign="middle">{row.numExecutors}</Table.Cell>
                                                                                        <Table.Cell verticalAlign="middle">{row.unionOpinion}</Table.Cell>
                                                                                        <Table.Cell verticalAlign="middle">{row.governmentApproval}</Table.Cell>
                                                                                        <Table.Cell verticalAlign="middle">{row.note}</Table.Cell>
                                                                                    </React.Fragment>
                                                                                )}

                                                                            <Table.Cell textAlign="center" verticalAlign="middle" style={{ whiteSpace: 'nowrap' }}>
                                                                                {row.id === editId ? (
                                                                                    <React.Fragment>
                                                                                        <Button
                                                                                            circular
                                                                                            color="blue"
                                                                                            icon="check"
                                                                                            size="tiny"
                                                                                            loading={loader}
                                                                                            onClick={this.saveRow}
                                                                                            disabled={loader}
                                                                                        />
                                                                                        <Button
                                                                                            circular
                                                                                            icon="close"
                                                                                            size="tiny"
                                                                                            basic
                                                                                            color="blue"
                                                                                            onClick={this.cancelEdit}
                                                                                            disabled={loader}
                                                                                        />
                                                                                    </React.Fragment>
                                                                                ) : this.state.deleteId === row.id ? (
                                                                                    <React.Fragment>
                                                                                        <Button
                                                                                            circular
                                                                                            icon="check"
                                                                                            color="blue"
                                                                                            size="tiny"
                                                                                            onClick={() => this.deleteRow(row.id)}
                                                                                        />
                                                                                        <Button
                                                                                            circular
                                                                                            icon="close"
                                                                                            basic
                                                                                            color="blue"
                                                                                            size="tiny"
                                                                                            onClick={this.cancelDelete}
                                                                                            // style={{ marginLeft: '0.5em' }}
                                                                                        />
                                                                                    </React.Fragment>
                                                                                ) : (
                                                                                    <React.Fragment>
                                                                                        <Popup
                                                                                            content="Izmjena"
                                                                                            position="top center"
                                                                                            trigger={
                                                                                                <Button
                                                                                                    basic
                                                                                                    circular
                                                                                                    color="green"
                                                                                                    icon="pencil"
                                                                                                    size="tiny"
                                                                                                    onClick={() => this.startEdit(row.id)}
                                                                                                />
                                                                                            }
                                                                                        />
                                                                                        <Popup
                                                                                            content="Obriši"
                                                                                            position="top center"
                                                                                            trigger={
                                                                                                <Button
                                                                                                    basic
                                                                                                    circular
                                                                                                    color="red"
                                                                                                    icon="trash alternate"
                                                                                                    size="tiny"
                                                                                                    onClick={() => this.setState({ deleteId: row.id })}
                                                                                                    // style={{ marginLeft: '0.5em' }}
                                                                                                />
                                                                                            }
                                                                                        />
                                                                                    </React.Fragment>
                                                                                )}
                                                                            </Table.Cell>
                                                                        </Table.Row>

                                                                )
                                                            )
                                                        }


                                                    </Table.Body>
                                                </Table>
                                            </div>
                                            : <NoDataMessage />
                                        }
                                        {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}

                                    </div>}
                    </Segment>
                </Segment.Group>
                <ToastContainer hideProgressBar />
            </div>
        );
    }



}

export default EmploymentList;



// WEBPACK FOOTER //
// ./src/views/HR/EmploymentList.js